import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SelectCell = ({ params, rows, setRows }) => {
	const { t } = useTranslation();

	const [type, setType] = useState(params.value);

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				height: "100%",
				minHeight: "84px",
			}}
		>
			<FormControl fullWidth>
				<InputLabel id={"l-type"}>
					{t(
						"timekeeper.schedule.table.modals.add.table.columns.type.title"
					)}
				</InputLabel>

				<Select
					labelId="l-type"
					id="type"
					value={type}
					label={t(
						"timekeeper.schedule.table.modals.add.table.columns.type.title"
					)}
					onChange={(event) => {
						setType(event.target.value);
						setRows(
							rows.map((row) =>
								row.id === params.row.id
									? { ...row, type: event.target.value }
									: row
							)
						);
					}}
				>
					<MenuItem value={"REGULAR"}>
						{t(
							"timekeeper.schedule.table.modals.add.table.columns.type.options.regular"
						)}
					</MenuItem>
					<MenuItem value={"BREAK"}>
						{t(
							"timekeeper.schedule.table.modals.add.table.columns.type.options.break"
						)}
					</MenuItem>
				</Select>
			</FormControl>
		</Box>
	);
};

export { SelectCell };
